import React from 'react';

export default function EmptyState({
	icon,
	iconAlt = 'Empty',
	message = 'No data found',
	detail,
	actionText,
	onActionClick,
	secondaryActionText,
	onSecondaryActionClick,
	actions: actionsProp,
	actionsContent,
	actionsInText = false,
	size,
	className
}) {
	const classNames = ['EmptyState'];
	if (detail) classNames.push('has-detail');
	if (actionsInText) classNames.push('actions-in-text');
	if (size) classNames.push(`size-${size}`);
	if (className) classNames.push(className);

	const actionItems = (
		actionsProp || [
			{ text: actionText, onClick: onActionClick },
			{ text: secondaryActionText, onClick: onSecondaryActionClick }
		]
	).filter(action => action && action.text && action.onClick);

	const actions = actionsContent ? (
		<div className="empty-state-actions">{actionsContent}</div>
	) : actionItems.length ? (
		<div className="empty-state-actions">
			{actionItems.map(action => (
				<button
					key={action.text}
					className="empty-state-action"
					onClick={action.onClick}>
					{action.text}
				</button>
			))}
		</div>
	) : null;

	return (
		<div className={classNames.join(' ')}>
			{icon && (
				<div className="empty-state-icon-wrapper">
					<img src={icon} alt={iconAlt} className="empty-state-icon" />
				</div>
			)}
			<div className="empty-state-text">
				{message ? <p className="empty-state-message">{message}</p> : null}
				{detail ? <p className="empty-state-detail">{detail}</p> : null}
				{actionsInText ? actions : null}
			</div>
			{!actionsInText ? actions : null}
		</div>
	);
}
